<template>
    <div>
        <div v-if="delete_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="p-5 position-content-main">
            <div class="breadcrumbnewtheme pb-3">
                <div class="pre gap-0p5 fw-500">
                    Settings
                </div>
                <span style="color:#b2bec3">/</span>
                <div class="pre gap-0p5 fw-500">
                    Templates
                </div>
                <span style="color:#b2bec3">/</span>
                <span class="curr gap-0p5 fw-500">
                    List View
                </span>
            </div>
            <div class="p-3 mt-3" style="background-color: #fff;border-radius: 10px;">
                <div class="tab-list d-flex align-items-center justify-content-between">
                    <!-- <ul class="d-flex align-items-center pl-0 pr-5 mb-0">
                        <li class="d-flex align-items-center ml-0 px-3" >
                            <span class="list-text text-dark fw-600">Template</span>
                            <span class="mx-2">|</span>
                            <span class="list-text-count" style="width: max-content;">{{total}} Total</span>
                        </li>
                    </ul> -->
                    <div>
                        <h3 class="text-secondary fw-500">Templates</h3>
                        <div class="text-secondary">{{total > 999 ? total.toLocaleString() : total}} Total</div>
                    </div>
                    <!-- <div class="w-100 search-bar">
                        <div class="w-100 position-relative">
                            <span>
                                <i class="icon icon-magnify align-position fs-18"></i>
                            </span>
                            <input type="text" class="search_input w-100" v-model="search_key" v-debounce:500ms="searchData" debounce-events="input" placeholder="Search by Template Name" />
                        </div>
                    </div> -->
                    <div>
                        <button @click="addTemplate" class="btn btn-success text-white text-capitalize add-btn mr-1">
                            <i class="icon icon-plus-circle-outline text-white"></i>
                            New Template
                        </button>
                    </div>
                </div>
                <div class="content mt-3">
                    <div>
                        <!-- <div v-if="ajax_call_in_progress" class="position-relative">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                        </div>
                        <div v-else> -->
                        <div>
                            <div class="table-content mb-3" style="overflow-x: auto !important;">
                                <table class="table table-content-data table-responsive w-100" style="border: solid 0.5px #f2f3f5;border-radius: 8px;">
                                    <thead>
                                        <tr>
                                            <th class="whiteSpace w-1">
                                                <span v-on:click="setPasskey('name')" class="cursor-th">
                                                    Template Name
                                                    <span v-if="passed_key.key=='name' && passed_key.value == -1" :class="{'hide-arrow': passed_key.key != 'name'}" class="sorting-icon">
                                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'name'}" class="sorting-icon">
                                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th class="whiteSpace w-1">
                                                <span v-on:click="setPasskey('template_type')" class="cursor-th" >
                                                    Template Type
                                                    <span v-if="passed_key.key=='template_type' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'template_type'}" class="sorting-icon">
                                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'template_type'}" class="sorting-icon">
                                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th class="whiteSpace w-1">
                                                <span v-on:click="setPasskey('created_date')" class="cursor-th" >
                                                    Creation Date
                                                    <span v-if="passed_key.key=='created_date' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'created_date'}" class="sorting-icon">
                                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th class="whiteSpace w-1">
                                                <span v-on:click="setPasskey('number_of_approves')" class="cursor-th" >
                                                    No. Of Approver Added
                                                    <span v-if="passed_key.key=='number_of_approves' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'number_of_approves'}" class="sorting-icon">
                                                        <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                    <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'number_of_approves'}" class="sorting-icon">
                                                        <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                                    </span>
                                                </span>
                                            </th>
                                            <th class="whiteSpace w-1">
                                                Created By
                                            </th>
                                            <th class="whiteSpace w-1">

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold">
                                            <td colspan="5">
                                                <div class="position-relative">
                                                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center font-weight-bold ht-100px">
                                            <td colspan="5">No Data Found</td>
                                        </tr>
                                        <tr v-else v-for="(data, index) in list_data" :key="index+'djdj'">
                                            <td class="whiteSpace pointer text-new-blue w-1" @click="goToViewPage(data._id)" :title="data.name">
                                                <div class="text-capitalize" style="overflow: hidden;text-overflow: ellipsis;width:200px;">{{data.name || "-"}}</div>
                                            </td>
                                            <td class="whiteSpace w-1 pointer" @click="goToViewPage(data._id)">
                                                <span class="text-capitalize">{{ data.template_type || "-"}}</span>
                                            </td>
                                            <td class="whiteSpace w-1 pointer" @click="goToViewPage(data._id)">
                                                <span>{{data.creation_date || "-"}}</span>
                                            </td>
                                            <td class="whiteSpace w-1 pointer" @click="goToViewPage(data._id)">
                                                <span>{{ data.number_of_approves || "0"}}</span>
                                            </td>
                                            <td class="whiteSpace w-1 pointer" @click="goToViewPage(data._id)">
                                                <span>{{data.created_by || "-"}}</span>
                                            </td>
                                            <td class="whiteSpace w-1">
                                                <span class="pointer whiteSpace buttons action-btns-show-hide">
                                                    <button class="btn btn-icon actionicons view " style="height: 25px;padding: 5px !important;" @click="previewTemplate(data._id)" v-if="data.name != 'Product Bug Template' && data.name != 'Digicollect Product Template' && data.can_edit">
                                                        <el-tooltip class="item" effect="dark" content="Preview" style="bottom: 4.5px;" placement="top">
                                                            <i class="icon icon-eye editIcon"></i>
                                                        </el-tooltip>
                                                    </button>
                                                    <button class="btn btn-icon actionicons view ml-3" style="height: 25px;padding: 5px !important;" @click="editTemplate(data._id)" v-if="data.name != 'Product Bug Template' && data.name != 'Digicollect Product Template' && data.can_edit">
                                                        <el-tooltip class="item" effect="dark" content="Edit" style="bottom: 4.5px;" placement="top">
                                                            <i class="icon icon-pencil editIcon"></i>
                                                        </el-tooltip>
                                                    </button>
                                                    <button class="btn btn-icon actionicons update ml-3" style="height: 25px;padding: 5px !important;" @click="deleteTemplateConfirm(data._id)" v-if="data.name != 'Product Bug Template' && data.name != 'Digicollect Product Template'">
                                                        <el-tooltip class="item" effect="dark" content="Delete" style="bottom: 4.5px;" placement="top">
                                                            <i class="icon icon-trash deleteIcon"></i>
                                                        </el-tooltip>
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-end">
                                <div class="d-flex align-items-center">
                                    <div class="pagination">
                                        <ul>
                                            <li class="btn navigate-btn" @click="previousPage()" :disabled="skip === 0">
                                                <span><i class="icon icon-chevron-left"></i></span>
                                            </li>
                                            <template v-if="total_pages <= 10">
                                                <li v-for="page in total_pages" :key="page" class="numb"
                                                    :class="{ active: page === curr_page }" @click="createPagination(page)">
                                                    <span>{{ page }}</span>
                                                </li>
                                            </template>
                                            <template v-else>
                                                <li class="numb" @click="createPagination(1)" :class="{ active: curr_page === 1 }">
                                                    <span>1</span>
                                                </li>
                                                <li v-if="curr_page > 4" class="dots"><span>...</span></li>
                                                <li v-for="index in Math.min(curr_page + 2, total_pages) - Math.max(curr_page - 2, 1) + 1"
                                                    :key="Math.max(curr_page - 2, 1) + index - 1"
                                                    v-if="Math.max(curr_page - 2, 1) + index - 1 <= total_pages && Math.max(curr_page - 2, 1) + index - 1 >= 2"
                                                    class="numb" :class="{ active: Math.max(curr_page - 2, 1) + index - 1 === curr_page }"
                                                    @click="createPagination(Math.max(curr_page - 2, 1) + index - 1)">
                                                    <span>{{ Math.max(curr_page - 2, 1) + index - 1 }}</span>
                                                </li>
                                                <li v-if="curr_page < total_pages - 3" class="dots"><span>...</span></li>
                                                <li v-if="total_pages > 5 && !lastPageClicked && curr_page <= total_pages - 3" class="numb"
                                                    @click="createPagination(total_pages)">
                                                    <span>{{ total_pages }}</span>
                                                </li>
                                            </template>
                                            <li class="btn navigate-btn" @click="nextPage()" :disabled="skip + limit >= total">
                                                <span><i class="icon icon-chevron-right"></i></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide" :options="pageLimit"
                                        :close-on-select="true" v-model.number="limit" @select="getAllTicketAPI" open-direction="top"
                                        :show-labels="false" placeholder=""
                                        style="width: 3em !important;padding-right: 10px!important; text-align: center !important;">
                                        <template slot="singleLabel">
                                            {{ limit }}
                                        </template>
                                    </multiselect>
                                    <span><strong>/pages</strong></span>
                    
                                </div>
                            </div>
                            <!-- <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
                                <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                                    :options="pageLimit" :close-on-select="true" v-model.number="limit"
                                    @search-change="fetchListData"
                                    open-direction="top" :show-labels="false" placeholder=""
                                    style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                                    style="margin-left: -35px;">
                                <span class="page-info pr-2 pl-6 fw-500"
                                    style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                                <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                        <i class="icon-chevron-double-left"></i>
                                    </el-tooltip>
                                </button>
                                <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                        <i class="icon icon-chevron-left"></i>
                                    </el-tooltip>
                                </button>
                                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                                <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                        <i class="icon icon-chevron-right"></i>
                                    </el-tooltip>
                                </button>
                                <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total+10 >= total">
                                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                        <i class="icon-chevron-double-right"></i>
                                    </el-tooltip>
                                </button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <create-template-popup 
            v-if="show_add_template" 
            @closeCreateTemplate="closeCreateTemplate" 
            :mode="mode"
            @reload_template_id="reloadTemplateId"
            :selected_template_id="selected_template_id"
            modal_name="CreateTemplatePopup">
        </create-template-popup>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';   
import dynamic_template from '../../mixins/dynamic_template'
const CreateTemplatePopup = () => import('./CreateTemplatePopup')
import Swal from 'sweetalert2';
export default {
    mixins: [dynamic_template],
    components: {
        SweetModal,
        CreateTemplatePopup,
        Swal
    },
    data() {
        return {
            delete_loader: false,
            success_msg:'',
            warning_msg:'',
            list_data: [],
            ajax_call_in_progress: false,
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
            passed_key: {
                key: 'created_date',
                value: -1
            },
            show_add_template: false,
            selected_template_id: '',
            mode: 'create',
            pageLimit: [],
            curr_page: 1,
            lastPageClicked: false,
            total_pages: 0,
            status_based_total: 0,
        }
    },
    methods: {
        searchData() {
            this.fetchListData()
        },
        goToViewPage(id) {
            this.$router.push('/dynamictemplate/view/'+id);
        },
        previewTemplate(id) {
            this.$router.push('/dynamictemplate/preview/'+id);
        },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            // this.searchData()
            this.fetchListData()
        },
        firstPage() {
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.skip_temp = 0
            this.list_data = []
            this.fetchListData()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total / this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.fetchListData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            this.temp_total = this.skip_temp;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            this.fetchListData();
        },
        previousPage() {
            this.temp_total = 0;
            this.skip_temp = 0;
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.curr_page = Math.ceil(this.skip / this.limit) + 1;
            this.fetchListData();
        },

        createPagination(page) {
            if (page === this.curr_page) {
                return;
            }
            this.curr_page = page;
            this.skip = (page - 1) * this.limit;
            this.fetchListData();
        },
        // firstPage(){
        //     this.temp_total = 0
        //     this.skip = 0
        //     this.limit = 10
        //     this.list_data = []
        //     this.fetchListData()
        // },
        // lastPage(){
        //     this.skip_temp = 0
        //     this.skip = 0
        //     this.temp_total = this.total
        //     let no_of_pages = Math.ceil(this.total/this.limit)
        //     this.skip_temp = (no_of_pages * this.limit) - this.limit
        //     if (this.skip_temp >= this.total) {
        //         return;
        //     }
        //     this.skip = this.skip_temp
        //     this.fetchListData();
        // },
        // nextPage() {
        //     this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
        //     if (this.skip_temp >= this.total) {
        //         return;
        //     }
        //     this.skip = this.skip_temp;
        //     this.fetchListData();
        // },
        // previousPage() {
        //     this.skip_temp = 0
        //     this.temp_total = 0
        //     if (this.skip == 0) {
        //         return;
        //     }
        //     this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
        //     this.fetchListData();
        // },
        addTemplate() {
            if(localStorage.getItem('storedTemplateData')){
                localStorage.removeItem('storedTemplateData')
            }
            this.mode = 'create'
            this.selected_template_id = ''
            this.show_add_template = true
            setTimeout(() => {
                this.$modal.show('CreateTemplatePopup')
            }, 500);
        },
        reloadTemplateId(id){
            this.selected_template_id = id
        },
        closeCreateTemplate(){
            this.show_add_template = false
        },
        editTemplate(id) {
            if(localStorage.getItem('storedTemplateData')){
                localStorage.removeItem('storedTemplateData')
            }
            this.mode = 'edit'
            this.selected_template_id = id
            this.show_add_template = true
            setTimeout(() => {
                this.$modal.show('CreateTemplatePopup')
            }, 1000);
        },
        deleteTemplateConfirm(id){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete ?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.isConfirmed == true) {
                    this.deleteTemplate(id)
                }
            })
        },
        async deleteTemplate(id) {
            this.delete_loader = true
            try {
                let params = {
                    dynamic_template_id: id
                };
                let response = await this.deleteDynamicTemplate(params);
                this.success_msg = response.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.delete_loader = false
                    this.$refs.success_modal.close();
                    this.fetchListData();
                }, 3000);
            }
            catch (error) {
                this.delete_loader = false
                this.warning_msg = err;
                this.$refs.warning_modal.open();
            }
        },
        async fetchListData() {
            this.list_data = [];
            this.status_based_total = 0
            this.total_pages = parseInt(this.status_based_total / this.limit)
            this.ajax_call_in_progress = true
            try {
                let params = {
                    limit: this.limit,
                    search_key: this.search_key,
                    skip: this.skip,
                    sort_key: this.passed_key.key,
                    sort_value: this.passed_key.value
                };
                let response = await this.listDynamicTemplate(params);
                this.list_data = response.response.dynamic_details
                this.list_data.forEach((e) => {
                    if(e.hasOwnProperty('template_type') && e.template_type.split('-').length == 2) {
                        e.template_type = e.template_type.replace('-', ' ')
                    } 
                    if(e.hasOwnProperty('template_type') && e.template_type.split('_').length == 2){
                        e.template_type = e.template_type.replace('_', ' ')
                    }
                })
                this.total = response.response.count;
                this.total_pages = parseInt(response.response.count / this.limit)
                console.log("hi")
                console.log(this.total_pages)
                this.status_based_total = response.response.count
                this.ajax_call_in_progress = false
            }
            catch (error) {
                this.ajax_call_in_progress = false
            }
        }
    },
    mounted() {
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        if(this.$route.query.call_type == 'redirection_mode'){
            if(localStorage.getItem('storedTemplateData')){
                let temp_template_data = JSON.parse(localStorage.getItem('storedTemplateData'))
                this.mode = temp_template_data.mode
            } else {
                this.mode = 'create'
            }
            this.selected_template_id = ''
            this.show_add_template = true
            setTimeout(() => {
                this.$modal.show('CreateTemplatePopup')
            }, 500);
        } else {
            localStorage.removeItem('storedTemplateData')
        }
        this.fetchListData();
    },
    watch: {
        limit: function(){
            this.fetchListData();
        }
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
}
</script>
<style scoped>
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }
    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }
    .search-bar{
        margin: 0 30px 0 30px;
    }
    .add-btn{
        margin-right: 24px;
        height: 34px;
    }
    .ht-100px{
        height: 100px;
    }
    .w-15{
        width: 15% !important
    }
    .w-1{
        width: 1% !important;
        min-width:250px !important
    }
    .table-content-data tr th{
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }
    .text-white{
        color: #fff !important;
    }
    .breadcrumbnewtheme{
        display: flex;
        align-items: center;
        gap: 1rem;
        border-bottom: 2px solid #636e71;
    }
    .breadcrumbnewtheme div{
        color: #00448b;
    }
    .fs-2rem{
        font-size: 2rem;
    }
    .position-content-main{
        border-radius: 14px;
        background-color: #f0ddb7;
    }
    .header-color{
        color: #4e4e4e !important;
    }
</style>